<template>
  <div class="page-container" v-if="newsData.title">
    <h1 class="page-title">{{ newsData.title }}</h1>
    <p style="text-align: right;">{{ newsData.date }}</p>
    <div class="content">
      <!-- 第一段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="contentParagraphs[0] || ''"></p>
        </div>
      </div>
     
      <!-- 图片部分：观看阅兵仪式 -->
      <div class="content-section image-section" v-if="newsData.other?.picture1">
        <div class="image-container">
          <img :src="newsData.other.picture1.url">
          <p class="image-caption">观看纪念大会直播</p>
        </div>
      </div>
     
      <!-- 第二段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="contentParagraphs[1] || ''"></p>
        </div>
      </div>
      
      <!-- 图片部分：阅兵仪式 -->
      <div class="content-section image-section" v-if="newsData.other?.picture2">
        <div class="image-container">
          <img :src="newsData.other.picture2.url">
          <p class="image-caption">阅兵仪式现场</p>
        </div>
      </div>
      
      <!-- 第三段内容：文字 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="contentParagraphs[2] || ''"></p>
        </div>
      </div>
      
      <!-- 图片部分：员工观看 -->
      <div class="content-section image-section" v-if="newsData.other?.picture3">
        <div class="image-container">
          <img :src="newsData.other.picture3.url">
          <p class="image-caption">员工集体观看大会直播</p>
        </div>
      </div>
    </div>
    
    
  </div>
  <div v-else class="page-container">
    <div class="back-button">
      <button @click="goBack" class="btn-back">back</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const router = useRouter();
const langStore = useLangStore();

// 根据当前语言选择对应的翻译数据
const translationData = computed(() => {
  return langStore.currentLang.startsWith('zh') ? zhData : enData;
});

// 获取新闻数据
const newsData = computed(() => {
  const newsList = translationData.value.pages.news.company.news.list;
  return newsList.find((item: any) => item.id === 'xinwen1') || {};
});

// 处理内容段落
const contentParagraphs = computed(() => {
  if (!newsData.value.content) return [];
  return newsData.value.content.split('---').filter((p: string) => p.trim());
});

const goBack = () => {
  router.push('/news/company');
};
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto;
  max-width: 1000px;
  margin: 0 auto;
  padding: 40px 20px;
}

.page-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  line-height: 1.4;
  text-align: center;
}

.content-section {
  margin-bottom: 20px;
}

.text-block {
  p {
    font-size: 16px;
    line-height: 1.8;
    color: #333;
    margin-bottom: 20px;
    text-align: justify;
    text-indent: 2em;
  }
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}

.back-button {
  text-align: center;
  margin-top: 50px;
  
  .btn-back {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 12px 30px;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    
    &:hover {
      background-color: #0056b3;
    }
  }
}

@media screen and (max-width: 768px) {
  .page-container {
    padding: 20px 15px;
  }
  
  .page-title {
    font-size: 24px;
  }
  
  .text-block {
    p {
      font-size: 15px;
      text-indent: 1.5em;
    }
  }
}
</style>